export function getLimitOfMaxTimes(unit: 'minute' | 'hour' | 'day') {
  switch (unit) {
    case 'minute': return 5;
    case 'hour': return 10;
    default: return 110;
  }
}
